import * as React from 'react';
import Link from '@mui/material/Link';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import Title from './Title';
import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';

import Projects from '../Data/sampleprojectdata.json';

const projectDetail = localStorage.getItem('projectName') && Projects.find(project => project.name === localStorage.getItem('projectName'))
const workOrderDetails = projectDetail && projectDetail.history

function preventDefault(event) {
    event.preventDefault();
}


export default function Workorders() {
    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        alert(panel)
        setExpanded(isExpanded ? panel : false);
    };

    return (

        <React.Fragment>

            <TableContainer component={Paper}>
                <Table size="small" aria-label="purchases">
                    <TableHead>
                        <TableRow>
                            <TableCell>Date</TableCell>
                            <TableCell>Work Order</TableCell>
                            <TableCell align="right">Description</TableCell>
                            <TableCell align="right">Total price ($)</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {workOrderDetails.map((historyRow) => (
                            <TableRow key={historyRow.workOrder}>
                                <TableCell component="th" scope="row">
                                    {historyRow.date}
                                </TableCell>
                                <TableCell>{historyRow.workOrder}</TableCell>
                                <TableCell align="right">{historyRow.description}</TableCell>
                                <TableCell align="right">{historyRow.cost}</TableCell>
                            </TableRow>
                        ))}

                    </TableBody>
                </Table>
            </TableContainer>

        </React.Fragment>
    );
}
